import React, { useContext } from "react";

import "./cart-lines-style.scss";
import { DeviceContext, deviceType } from '@providers';

import Typography from "@src/componentsNew/Typography/Typography";
import SellerCartLines from "@src/componentsNew/Cart/SellerCartLines";
import DesktopFreebieCartLine from "@src/componentsNew/Cart/DesktopFreebieCartLine";
import MobileFreebieCartLine from "@src/componentsNew/Cart/MobileFreebieCartLine";

import { CartSubCartsType, CartSubCartsLinesType } from "@src/utils/types";
import { checkoutQuery_checkout_subcarts_lines } from "@src/components/pages/CheckoutPage/__generated__/checkoutQuery";

interface IProps {
  activeCart: 'maccaron' | 'mgs';
  loading: boolean;
  subcarts: (CartSubCartsType | null)[] | null;
  freebies: (CartSubCartsLinesType | checkoutQuery_checkout_subcarts_lines | null)[];
  updateCartLine: any;
  deleteCartLine: any;
  cartLineToWishlist: any;
}

const CartLines = ({
  activeCart,
  loading,
  subcarts,
  freebies,
  updateCartLine,
  deleteCartLine,
  cartLineToWishlist
}: IProps) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    <div className="cart-lines-container">
      <div className="not-freebie-container">
        {
          subcarts?.map((subcart) => {
            const notFreebieLines = subcart?.lines?.filter((line) => !line.isFreebie);

            return (
              notFreebieLines?.length > 0 && (
                <SellerCartLines
                  key={subcart?.seller?.name}
                  activeCart={activeCart}
                  loading={loading}
                  subcart={subcart}
                  updateCartLine={updateCartLine}
                  deleteCartLine={deleteCartLine}
                  cartLineToWishlist={cartLineToWishlist}
                />
              )
            );
          })
        }
      </div>

      {
        freebies.length > 0 &&
        <div className={`freebie-container ${isMobile ? 'mobile' : ''}`}>
          <div className={`freebie-area-divider ${isMobile ? 'mobile' : ''}`}>
            <Typography variant="body2" component="span" style={{ color: "#666666" }}>
              Freebie
            </Typography>
            {
              !isMobile && (
                <div className="freebie-line" />
              )
            }
          </div>

          <div className="freebie-lines-wrapper">
            {
              freebies?.map((freebieLine) => (
                isMobile ? (
                  <MobileFreebieCartLine
                    key={freebieLine?.id}
                    line={freebieLine}
                  />
                ) : (
                  <DesktopFreebieCartLine
                    key={freebieLine?.id}
                    line={freebieLine}
                  />
                )
              ))
            }
          </div>
        </div>
      }
    </div>
  );
};

export default CartLines;
